import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { AppConstants } from "../../app.constants";
import { Observable, of } from "rxjs";
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorHandlerService } from "src/app/core/services/error-handler.service";
@Injectable({
  providedIn: 'root'
})
export class LitigationComplaintsService {

  constructor(private http: HttpClient, private router: Router, private errorHandlerService: ErrorHandlerService) { }

  getLitigationComplaintsData(email): Observable<any> {
    const params = new HttpParams()
      .set('user_email', email.toString());
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LITIGATION_COMPLAINTS.COMPLAINTS_DATA}`, { params }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }

  getViewAllLitigationComplaintsData(data): Observable<any> {
    return this.http.post(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LITIGATION_COMPLAINTS.VIEW_ALL_COMPLAINTS_DATA}`, data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  // https://portfoliodev.pharsights.com/pm_backend/info/rerun_litigation_logic/
  rerunlitigationLogic(data): Observable<any> {
    return this.http.post(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LITIGATION_COMPLAINTS.RERUN_LITIGATION_LOGIC}`, data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  getMostSearcgProducts(data): Observable<any> {
    return this.http.post(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LITIGATION_COMPLAINTS.GET_MOST_SEARCHED_PRODUCTS}`, data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  getUserAndCompanyData(email): Observable<any> {
    const params = new HttpParams()
      .set('user_email', email.toString());
    return this.http.get(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LITIGATION_COMPLAINTS.GET_USER_COMPANY}`, { params }
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
  getCompanyMasterData(data): Observable<any> {
    return this.http.post(
      `${AppConstants.API_ENDPOINT}${AppConstants.API.LITIGATION_COMPLAINTS.GET_COMPANY_MASTER}`, data
    ).pipe(catchError((error) => this.errorHandlerService.handleError(error)));
  }
}